import {PDFInfo} from "../../../../misc/pdf/PrintManager";
import {Company} from "../../../../api/Companies";
import {Contact} from "../../../../api/Contacts";
import {Project} from "../../../../api/Projects";
import {GlazingPDF} from "./GlazingPDF";
import {GlazingPageItem} from "./GlazingPagesTab";
import {loadGlazingSections} from "./GlazingSections";

export type GlazingSubData = {
    client?: Company;
    clientContact?: Contact;
    project: Project;
    notes: string;
    pages: GlazingPageItem[];
    lastSubmission: string | null;
    // the openings to report on — the ones listed in the grid the submittal was started from.
    openings: number[];
    // quote mode: the alternative the openings belong to.
    alternative?: number;
};

export function getGlazingSubmittal(props: {
    projectId: number;
    getData(): Promise<GlazingSubData>;
}): PDFInfo {
    return {
        name: "glazing-submittal.pdf",
        render: async (onReady, config) => {
            const d = await props.getData();

            const sections = await loadGlazingSections({
                project: d.project.id,
                alternative: d.alternative,
                openings: d.openings,
            });

            return (
                <GlazingPDF
                    onReady={onReady}
                    project={d.project}
                    client={d.client}
                    clientContact={d.clientContact}
                    notes={d.notes}
                    pages={d.pages}
                    lastSubmittal={d.lastSubmission}
                    screens={sections.screens}
                    doors={sections.doors}
                />
            );
        },
        serverInfo: {
            submissionForProject: props.projectId,
            submissionType: "glazing",
        }
    };
}
